import { getCounterpartyType } from '../../../../../../utils/pendingConciliation'
import { getConciliationBalanceRows, getConciliationBalanceAmount, getRemovedConciliationAdjustment } from '../../../../../../utils/conciliationBalanceRows'
import ConciliationAdjustmentAmount from '../../../../../ui/ConciliationAdjustmentAmount'
import { getConciliationAdjustmentDisplay } from '../../../../../../utils/conciliationAdjustmentDisplay'
import { applyConciliationAdjustment } from '../../../../../../utils/conciliationAdjustment'
import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
import { getConciliationRenderKey, mergeConciliationRows } from '../../../../../../utils/conciliationRows'
import { getVinculacionAvailableAmount, getVinculacionAppliedAmount, getVinculacionPendingAmount } from '../../../../../../utils/vinculacionAmounts'
import AssignedAmountInput from '../../../../../modalDialogEditarMovBancario/AssignedAmountInput'
import { buildBankConciliationPayload, routeEditedConciliationAmounts } from '../../../../../modalDialogEditarMovBancario/bankConciliationPayload'
import { useContext, useEffect, useMemo, useState } from 'react'
import GlobalContext from '../../../../../../../context/global-context'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import ListVincularArriendo from '../modalDialogPorVincular/ListVincularArriendo'
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { bankIcons } from '../../../../../../modules/views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import { Button, Text } from '../../../../../ui'
import ResizableModal from '../../../../../ui/ResizableModal'
import ConfirmConciliationModal from '../../../../../ui/ConfirmConciliationModal'
import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../../../../../queries/querykeys'
import { normalizeConciliationPayload } from '../../../../../../utils/normalizeConciliationLinkage'
import { REACT_APP_RECONCILIATION_API_URL } from '../../../../../../utils/constant'
const ModalConciliarVinculacion = ({open,setOpen,idLibro,type,fVenc,folio,status,setSwitchGetData,folioCredito,auxiliar,row,nombreOrigen,origenTabla,cuotaPrestamo,forceFormulario29 = false}) => {
  const [data, setData] = useState({})
  const folioPrestamo = Number(folioCredito ?? row?.folioCredito ?? data?.folioCredito)
  const documentMovementType = cuotaPrestamo && [4, 6].includes(folioPrestamo)
    ? folioPrestamo === 6 ? 'compra' : 'venta'
    : getCounterpartyType({ ...row, ...data, type: data?.tipoMovimiento ?? row?.tipoMovimiento ?? type })
  const { ui, currentBusiness } = useContext(GlobalContext)
  const queryClient = useQueryClient()
  const organizationAPI = new OrganizationAPI()
  const [, setFecha] = useState('')
  const [, setGlosa] = useState('')
  const [, setTipoContrato] = useState('')
  const [, setMonto] = useState('')
  const [, setRut] = useState('')
  const [, setRazonSocial] = useState('')
  const [, setIsPagado] = useState(false)
  const [loading, setLoading] = useState(false)
  const [, setMovimientoSeleccionado] = useState(null)
  const [, setInitialSelectedIds] = useState([])
  const [selectedBank, setSelectedBank] = useState('')
  const [selectedDataByOrigen, setSelectedDataByOrigen] = useState({})
  const [editedAmounts, setEditedAmounts] = useState({})
  useEffect(() => { setEditedAmounts({}) }, [open, idLibro, currentBusiness?.id])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({})
  const [selectedIds, setSelectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: [],
    anticipo: []
  })
  const [unselectedIds, setUnselectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: [],
    anticipo: []
  })
  const [useCajaPrincipal, setUseCajaPrincipal] = useState(false)
  const [origenSeleccionado, setOrigenSeleccionado] = useState([])
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  const [f29ReconciliationDetail, setF29ReconciliationDetail] = useState(null)

  const isFormulario29 = useMemo(() => {
    if (forceFormulario29) return true
    if (Number(origenTabla ?? data?.origenTabla ?? row?.origenTabla) === 37) return true

    const labels = [
      data?.razonSocial,
      data?.nombreFolio,
      data?.nombreCuenta,
      data?.descripcion,
      data?.glosa,
      data?.tipoDocumento,
      row?.razonSocial,
      row?.nombreFolio,
      row?.nombreCuenta,
      row?.descripcion,
      row?.glosa
    ]

    return labels.some(label => {
      const normalized = String(label ?? '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return (
        /(^|\W)f\W*29($|\W)/.test(normalized) ||
        /formulario\D*29/.test(normalized)
      )
    })
  }, [data, forceFormulario29, origenTabla, row])

  const origenTablaSeleccionado = Number(
    origenTabla ?? row?.origenTabla ?? data?.origenTabla
  )
  const linkageDocumentoSeleccionado = useMemo(
    () =>
      cuotaPrestamo
        ? (data?.linkage ?? []).filter(item =>
          Number(item?.idCuota) === Number(cuotaPrestamo.idCuota) && Number(item?.idPrincipal) > 0
        )
        : (origenTablaSeleccionado === 48
        ? data?.linkagePrevired ?? []
        : data?.linkage ?? []
      ).filter(item => Number(item?.score) !== -7),
    [cuotaPrestamo, data?.linkage, data?.linkagePrevired, origenTablaSeleccionado]
  )
  const dataDocumentoSeleccionado = useMemo(
    () => ({ ...data, linkage: linkageDocumentoSeleccionado }),
    [data, linkageDocumentoSeleccionado]
  )
  const nombreDocumentoSeleccionado =
    cuotaPrestamo ? cuotaPrestamo.descripcion : origenTablaSeleccionado === 39
      ? 'Formulario 29'
      : origenTablaSeleccionado === 48
        ? 'IVA Postergado'
        : null

  const libroIdConciliacion = useMemo(() => {
    if (cuotaPrestamo) return Number(cuotaPrestamo.idCuota)
    if (origenTablaSeleccionado === 39) {
      return Number(data?.idLiquido ?? row?.idLiquido ?? idLibro)
    }
    if (origenTablaSeleccionado === 48) {
      return Number(data?.idPrevired ?? row?.idPrevired ?? idLibro)
    }
    return nombreOrigen === 'sii' ? Number(data?.idPrevired ?? idLibro) : Number(idLibro)
  }, [cuotaPrestamo, data?.idLiquido, data?.idPrevired, idLibro, nombreOrigen, origenTablaSeleccionado, row])

  const montoDocumentoSeleccionado = useMemo(() => {
    if (cuotaPrestamo) return cuotaPrestamo.total
    const esPrestamo = [4, 6].includes(Number(folioCredito ?? data?.folioCredito ?? row?.folioCredito))
    if (esPrestamo) {
      return data?.montoTotal ?? row?.montoTotal
    }
    if (origenTablaSeleccionado === 39) {
      return data?.totalCargo ?? row?.totalCargo ?? data?.montoTotal ?? row?.montoTotal
    }
    if (origenTablaSeleccionado === 48) {
      return data?.totalPrevired ?? data?.totalprevired ??
        row?.totalPrevired ?? row?.totalprevired ??
        data?.montoTotal ?? row?.montoTotal
    }
    return isFormulario29 || nombreOrigen === 'sii'
      ? data?.montoNeto ?? row?.montoTotal
      : data?.montoTotal ?? row?.montoTotal
  }, [cuotaPrestamo, data, folioCredito, isFormulario29, nombreOrigen, origenTablaSeleccionado, row])

  const getRowId = item => {
    if (!item) return undefined
    if (item.tipo === 'caja')
      return `custom-caja-${item.id || item.nombreCuentaBanco || 'principal'}`
    return (
      item?.idPrincipal ??
      item?.id_principal ??
      item?.egreso?.idPrincipal ??
      item?.ingreso?.idPrincipal ??
      item?.linkage?.idPrincipal ??
      item?.id
    )
  }

  const toNumId = rid => {
    const n = Number(rid)
    return Number.isFinite(n) ? n : null
  }

  const serverLinkedIdSet = useMemo(() => {
    const ids = linkageDocumentoSeleccionado
      .map(it => toNumId(getRowId(it)))
      .filter(n => n !== null)
    return new Set(ids)
  }, [linkageDocumentoSeleccionado])

  const isLinkedOnServerByRowId = rid => {
    const n = toNumId(rid)
    return n !== null && serverLinkedIdSet.has(n)
  }

  const selectedRowsData = Object.entries(selectedDataByOrigen)
    .flatMap(([origen, rows]) =>
      (rows ?? []).map(r => ({
        ...r,
        _origen: origen,
        montoEditable:
          r.nombreCuenta === 'Boletas de Honorarios'
            ? r.montoNetoLiquido ?? 0
            : getVinculacionAppliedAmount(r)
      }))
    )

  const getItemAmountForSum = item => {
    if (editedAmounts[getRowId(item)] != null) return editedAmounts[getRowId(item)]
    if (item?.customRow === true && item?.montoEditable != null) {
      return Math.abs(Number(item.montoEditable) || 0)
    }
    const linked = getLinkedItem(item)
    return linked ? getConciliationBalanceAmount(linked, linkageDocumentoSeleccionado) : getVinculacionAvailableAmount(item)
  }
  const getLinkedItem = item => linkageDocumentoSeleccionado.find(
    linked => String(getRowId(linked)) === String(getRowId(item)) &&
      (item.idCuota == null && item.idcuota == null ||
        String(linked.idCuota ?? linked.idcuota) === String(item.idCuota ?? item.idcuota))
  )
  const getMovementDate = item => {
    const linked = getLinkedItem(item)
    return linked ? linked.fechaRelacionada : item.fecha
  }

  const hasSelectedOrigen = useMemo(
    () => Object.keys(selectedDataByOrigen || {}).length > 0,
    [selectedDataByOrigen]
  )

  const rowsBase = useMemo(
    () => mergeConciliationRows(linkageDocumentoSeleccionado, selectedRowsData),
    [hasSelectedOrigen, selectedRowsData, linkageDocumentoSeleccionado]
  )

  const rowsToShow = useMemo(() => {
    const allUnselected = Object.values(unselectedIds || {}).flat()
    return rowsBase.filter(it => {
      const n = toNumId(getRowId(it))
      return !(n !== null && allUnselected.includes(n))
    })
  }, [rowsBase, unselectedIds])

  useEffect(() => {
    const nextMap = {}
    Object.values(selectedDataByOrigen || {})
      .flat()
      .forEach(item => {
        const primaryKey = item?.id != null ? String(item.id) : null
        const secondaryKey = getRowId(item)
        if (primaryKey) {
          nextMap[primaryKey] = true
        }
        if (secondaryKey != null) {
          nextMap[String(secondaryKey)] = true
        }
      })
    setSelectedCheckboxes(nextMap)
  }, [selectedDataByOrigen])

  const totalAplicado = useMemo(
    () =>
      rowsToShow.reduce((acc, it) => acc + getItemAmountForSum(it), 0),
    [rowsToShow, editedAmounts]
  )

  const totalDocumento = useMemo(
    () => Math.abs(Number(montoDocumentoSeleccionado ?? 0)),
    [montoDocumentoSeleccionado]
  )

  const saldoAuxiliar = cuotaPrestamo
    ? cuotaPrestamo.auxiliar
    : data.auxiliar ?? data.deuda?.auxiliar ?? auxiliar
  const totalVinculado = getConciliationBalanceRows(linkageDocumentoSeleccionado).reduce(
    (acc, item) => acc + getVinculacionAppliedAmount(item), 0
  )
  const saldoRestante = getVinculacionPendingAmount(
    saldoAuxiliar, totalDocumento, totalVinculado, totalAplicado
  ) + (saldoAuxiliar != null && String(saldoAuxiliar).trim() !== '' && Number.isFinite(Number(saldoAuxiliar))
    ? getRemovedConciliationAdjustment(linkageDocumentoSeleccionado, rowsToShow, totalDocumento) : 0)
  const estadoDocumento = data.status ?? status

  const handleCurrentData = origen => rows => {
    setSelectedDataByOrigen(prev => ({
      ...prev,
      [origen]: rows
    }))
  }

  const handleClose = () => {
    setOpen(false)
    setSwitchGetData(true)
  }
  const handleSeleccionarMovimiento = movimiento => {
    setMovimientoSeleccionado(movimiento)
    setIsPagado(true)
  }

  const functionGetData = async () => {
    try {
      setLoading(true)
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness?.id,
        idLibro,
        type.trim()
      )
      setData(normalizeConciliationPayload(response.data))
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getF29ReconciliationDetail = async () => {
    if (
      !currentBusiness?.id ||
      !libroIdConciliacion ||
      !isFormulario29
    ) {
      setF29ReconciliationDetail(null)
      return
    }

    const params = new URLSearchParams({
      businessId: String(currentBusiness.id),
      idLibro: String(libroIdConciliacion)
    })

    try {
      const response = await fetch(
        `${REACT_APP_RECONCILIATION_API_URL}/f29/conciliacion/movimientos?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }
      )

      if (!response.ok) {
        throw new Error(
          `Error consultando detalle de conciliación F29: ${response.status}`
        )
      }

      const detail = await response.json()


      setF29ReconciliationDetail(detail)
    } catch (error) {
      console.error(
        'No fue posible obtener el detalle de conciliación F29:',
        error
      )

      // El modal nativo de Luca debe seguir funcionando
      // aunque nuestro servicio E2E no esté disponible.
      setF29ReconciliationDetail(null)
    }
  }

    const saveF29ReconciliationReview = async ({
      engineIdLibros,
      effectiveIdLibros
    }) => {
      if (
        !currentBusiness?.id ||
        !f29ReconciliationDetail?.period
      ) {
        return
      }

      const response = await fetch(
        `${REACT_APP_RECONCILIATION_API_URL}/f29/conciliacion/review`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            businessId: Number(currentBusiness.id),
            period: f29ReconciliationDetail.period,
            f29Key: f29ReconciliationDetail.f29Key,
            engineIdLibros,
            effectiveIdLibros,
            metadata: {
              executionSource: 'frontend_luca',
              action: 'guardar_conciliacion'
            }
          })
        }
      )

      if (!response.ok) {
        throw new Error(
          `Error persistiendo revisión de conciliación F29: ${response.status}`
        )
      }

      return response.json()
    }

  useEffect(() => {
    if (open) {
      functionGetData()
    }
  }, [])

  useEffect(() => {
    if (
      !open ||
      !isFormulario29 ||
      !currentBusiness?.id ||
      !libroIdConciliacion
    ) {
      setF29ReconciliationDetail(null)
      return
    }

    getF29ReconciliationDetail()
  }, [
    open,
    isFormulario29,
    currentBusiness?.id,
    libroIdConciliacion
  ])

 const handleDesvincular = async ids => {
  const numericIds = Array.from(
    new Set((Array.isArray(ids) ? ids : []).map(toNumId).filter(id => id !== null))
  );
  if (numericIds.length === 0) return;
  const libroIdFinal = libroIdConciliacion;
  const payload = { ids: numericIds };
  try {
    const esPrestamoOCuota = Boolean(cuotaPrestamo) ||
      [4, 5, 6, 7].includes(Number(folioCredito ?? data?.folioCredito ?? row?.folioCredito));
    if (esPrestamoOCuota) {
      await organizationAPI.postCajaMultipleDes(
        { businessId: Number(currentBusiness.id) },
        payload
      );
      return;
    }
    await organizationAPI.postDesvincular(
      {
        businessId: Number(currentBusiness.id),
        idLibro: libroIdFinal
      },
      payload
    );
  } catch (error) {
    console.error('Error al desvincular:', error);
    throw error;
  }
};

const handleSubmit = async (ajusteAEnviar = false) => {
  try {
    ui.setLoader({ visible: true })

    // --- Snapshot E2E antes de modificar Luca ---
    const engineIdLibros = [
      ...new Set(
        (f29ReconciliationDetail?.movements ?? [])
          .map(item => toNumId(item?.idLibro))
          .filter(id => id !== null)
      )
    ]

    const effectiveIdLibros = [
      ...new Set(
        (rowsToShow ?? [])
          .map(item => toNumId(getRowId(item)))
          .filter(id => id !== null)
      )
    ]

    const bancoUnselected = unselectedIds.banco?.length ?? 0
    const cajaUnselected = unselectedIds.caja?.length ?? 0
    const anticipoUnselected = unselectedIds.anticipo?.length ?? 0

    if (bancoUnselected > 0) {
      await handleDesvincular(unselectedIds.banco)
    }

    if (cajaUnselected > 0) {
      await handleDesvincular(unselectedIds.caja)
    }

    if (anticipoUnselected > 0) {
      await handleDesvincular(unselectedIds.anticipo)
    }

    const hayAlgoParaVincular =
      (selectedDataByOrigen.contraparte?.length ?? 0) > 0 ||
      (selectedDataByOrigen['banco']?.length ?? 0) > 0 ||
      (selectedDataByOrigen['caja']?.length ?? 0) > 0 ||
      (selectedDataByOrigen['anticipo']?.length ?? 0) > 0

    const hayAlgoParaDesvincular =
      bancoUnselected > 0 ||
      cajaUnselected > 0 ||
      anticipoUnselected > 0

    // --- Solo desvinculación: persistir review antes de cerrar ---
    if (hayAlgoParaDesvincular && !hayAlgoParaVincular) {
      if (isFormulario29) {
        await saveF29ReconciliationReview({
          engineIdLibros,
          effectiveIdLibros
        })
      }

      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.SUMMARY_MOVEMENTS_FROM_TO]
      })

      setSwitchGetData(true)
      handleClose()
      return
    }

    const dto = {
      datoBanco: { ids: [] },
      datoBoleta: { ids: [] },
      datoCaja: {},
      datoCajaLastYear: {},
      instrucciones: []
    }

    let bancoFlag = false
    let cajaFlag = false
    let gestionFlag = false
    let boletaFlag = false

    const bancoRows = rowsToShow.filter(item => item._origen === 'banco' || item.tipo === 'banco' ||
      (!item._origen && !item.tipo && [6, 7].includes(Number(item.tablaPrincipal ?? item.tabla))))
    const idsBanco = bancoRows.map(getRowId).filter(id => Number(id) > 0)

    if (idsBanco.length > 0) {
      const routed = routeEditedConciliationAmounts(buildBankConciliationPayload(idsBanco,
        bancoRows.map(item => ({ ...item, id: getRowId(item), idPrincipal: getRowId(item) })), editedAmounts), { ids: [] })
      dto.datoBanco = routed.datoBanco
      dto.datoBoleta = routed.datoBoleta
      bancoFlag = routed.instrucciones[0]
      boletaFlag = routed.instrucciones[1]
    }

    const calcularMontoCaja = rows =>
      rows.reduce(
        (acc, item) =>
          acc + (item.montoEditable ?? item.montoTotal ?? 0),
        0
      )

    const rowsCaja = selectedDataByOrigen['caja'] ?? []

    if (rowsCaja.length > 0) {
      dto.datoCaja = {
        monto: calcularMontoCaja(rowsCaja)
      }
      cajaFlag = true
    }

    dto.instrucciones = [
      bancoFlag,
      boletaFlag,
      cajaFlag,
      gestionFlag
    ]

    const libroIdFinal = libroIdConciliacion

    const idsPagoAnticipo = (
      selectedDataByOrigen['anticipo'] ?? []
    )
      .map(item => item.idPrincipal ?? item.id)
      .filter(id => id != null)
      .map(Number)

    const counterpartIds = (selectedDataByOrigen.contraparte ?? []).map(item => Number(item.idPrincipal ?? item.id)).filter(id => id > 0)
    if (counterpartIds.length > 0) {
      if (Array.isArray(dto.datoBanco)) {
        await organizationAPI.postForInOne(
          { businessId: Number(currentBusiness.id), idLibro: libroIdFinal },
          { ...dto, datoBoleta: { ids: [] }, datoCaja: {}, datoCajaLastYear: {}, instrucciones: [true, false, false, false] }
        )
        dto.datoBanco = { ids: [] }
      }
      dto.datoBanco = {
        ...dto.datoBanco,
        ids: [...new Set([...(dto.datoBanco.ids ?? []), ...counterpartIds])]
      }
      bancoFlag = true
      dto.instrucciones = [bancoFlag, boletaFlag, cajaFlag, gestionFlag]
    }
    if (idsPagoAnticipo.length > 0) {
      await organizationAPI.postListaVincular(
        {
          businessId: Number(currentBusiness.id),
          idLibro: libroIdFinal,
          din: true
        },
        {
          ids: idsPagoAnticipo
        }
      )
    }

    if (
      ajusteAEnviar ||
      bancoFlag ||
      cajaFlag ||
      gestionFlag ||
      boletaFlag
    ) {
      await organizationAPI.postForInOne(
        {
          businessId: Number(currentBusiness.id),
          idLibro: libroIdFinal
        },
        applyConciliationAdjustment(dto, ajusteAEnviar)
      )
    }

    // --- Persistir revisión humana F29 ---
    if (isFormulario29) {
      await saveF29ReconciliationReview({
        engineIdLibros,
        effectiveIdLibros
      })
    }

    await queryClient.invalidateQueries({
      queryKey: [QueryKeys.SUMMARY_MOVEMENTS_FROM_TO]
    })

    setSwitchGetData(true)
    handleClose()
  } catch (error) {
    console.error('Error en la conciliación:', error)
  } finally {
    ui.setLoader({ visible: false })
  }
}

// const handleSubmit = async () => {
//   try {
//     ui.setLoader({ visible: true });

//     const bancoUnselected = unselectedIds.banco?.length ?? 0;
//     const cajaUnselected = unselectedIds.caja?.length ?? 0;
//     const anticipoUnselected = unselectedIds.anticipo?.length ?? 0;

//     if (bancoUnselected > 0) {
//       await handleDesvincular(unselectedIds.banco);
//     }

//     if (cajaUnselected > 0) {
//       await handleDesvincular(unselectedIds.caja);
//     }

//     if (anticipoUnselected > 0) {
//       await handleDesvincular(unselectedIds.anticipo);
//     }

//     const hayAlgoParaVincular =
//       (selectedDataByOrigen['banco']?.length ?? 0) > 0 ||
//       (selectedDataByOrigen['caja']?.length ?? 0) > 0 ||
//       (selectedDataByOrigen['anticipo']?.length ?? 0) > 0;

//     const hayAlgoParaDesvincular =
//       bancoUnselected > 0 || cajaUnselected > 0 || anticipoUnselected > 0;

//     if (hayAlgoParaDesvincular && !hayAlgoParaVincular) {
//       await queryClient.invalidateQueries({
//         queryKey: [QueryKeys.SUMMARY_MOVEMENTS_FROM_TO]
//       });
//       setSwitchGetData(true);
//       handleClose();
//       return;
//     }

//     const dto = {
//       datoBanco: { ids: [] },
//       datoBoleta: { ids: [] },
//       datoCaja: {},
//       datoCajaLastYear: {},
//       instrucciones: []
//     };

//     let bancoFlag = false;
//     let cajaFlag = false;
//     let gestionFlag = false;
//     let boletaFlag = false;

//     const idsBanco = (selectedDataByOrigen['banco'] ?? []).map(item => item.idPrincipal);
//     if (idsBanco.length > 0) {
//       dto.datoBanco = { ids: idsBanco.map(Number) };
//       bancoFlag = true;
//     }

//     const calcularMontoCaja = rows =>
//       rows.reduce(
//         (acc, item) => acc + (item.montoEditable ?? item.montoTotal ?? 0),
//         0
//       );

//     const rowsCaja = selectedDataByOrigen['caja'] ?? [];
//     if (rowsCaja.length > 0) {
//       dto.datoCaja = { monto: calcularMontoCaja(rowsCaja) };
//       cajaFlag = true;
//     }

//     dto.instrucciones = [bancoFlag, boletaFlag, cajaFlag, gestionFlag];

//     const libroIdFinal = libroIdConciliacion;

//     const idsPagoAnticipo = (selectedDataByOrigen['anticipo'] ?? [])
//       .map(item => item.idPrincipal ?? item.id)
//       .filter(id => id != null)
//       .map(Number);

//     if (idsPagoAnticipo.length > 0) {
//       await organizationAPI.postListaVincular(
//         {
//           businessId: Number(currentBusiness.id),
//           idLibro: libroIdFinal,
//           din: true
//         },
//         { ids: idsPagoAnticipo }
//       );
//     }

//     if (bancoFlag || cajaFlag || gestionFlag || boletaFlag) {
//       await organizationAPI.postForInOne(
//         {
//           businessId: Number(currentBusiness.id),
//           idLibro: libroIdFinal
//         },
//         dto
//       );
//     }

//     await queryClient.invalidateQueries({
//       queryKey: [QueryKeys.SUMMARY_MOVEMENTS_FROM_TO]
//     });
//     setSwitchGetData(true);
//     handleClose();
//   } catch (error) {
//     console.error('Error en la conciliación:', error);
//   } finally {
//     ui.setLoader({ visible: false });
//   }
// }

  useEffect(() => {
    if (data) {
      if (data.fecha) {
        const parsedDate = new Date(data.fecha)
        const formattedDate = parsedDate.toISOString().split('T')[0]
        setFecha(formattedDate)
      }
      if (data.fechaVencimiento) {
        const parsedDate = new Date(data.fecha)
        const formattedDate = parsedDate.toISOString().split('T')[0]
        setFecha(formattedDate)
      }
      if (data.glosa) setGlosa(data.glosa)
      if (data.montoTotal) setMonto(data.montoTotal.toString())
      if (data.razonSocial) setRazonSocial(data.razonSocial)
      if (data.rut) setRut(data.rut)
      if (data.pagado !== undefined) setIsPagado(data.pagado)
      if (data.tipoContrato) setTipoContrato(data.tipoContrato)
    }
  }, [data])

  const mapFolio = {
    0: 'Pago Arriendos',
    1: 'Cobro Arriendos',
    2: 'Gastos Comunes',
    3: 'Retiro Dividendo',
    4: 'Prestamo Otorgado',
    5: 'Cobro Cuota Prestamo',
    6: 'Credito Consumo',
    7: 'Pago Cuota Prestamo',
    8: 'Pago Patente Comercial',
    9: 'Pago Contribuciones',
    10: 'Aporte Transitorio Socio',
    11: 'Devolucion Aporte Transitorio',
    12: 'Rendicion Gastos',
    13: 'Invoice Compra',
    14: 'Invoice Venta',
    15: 'Finiquitos',
    16: 'Inversiones dap',
    17: 'Inversiones ffmm',
    18: 'Inversiones otras',
    19: 'Acciones en bolsa',
    20: 'Criptomonedas',
    21: 'Otros valores negociables',
    22: 'Ajuste Existencias',
    23: 'Pago año anterior',
    24: 'Cobro año anterior',
    25: 'Vinculación Generica Cargo',
    26: 'Vinculación Generica Abono',
    27: 'Anticipo Agente de Aduana',
    28: 'Anticipo Sueldo',
    29: 'Multas',
    30: 'Devolución Agente Aduana',
    31: 'Previred año anterior',
    32: 'Remuneración año anterior',
    33: 'Aporte Empresa Relacionada',
    34: 'Devolución Empresa Relacionada',
    35: 'Invoice Importaciones',
    36: 'Devolución de Impuestos',
  }

  const formatRut = (input = '') => {
    let cleaned = String(input ?? '').replace(/[^0-9kK]/g, '').toUpperCase()
    // Limita a 9 caracteres (8 cuerpo + 1 DV)
    if (cleaned.length > 9) cleaned = cleaned.slice(0, 9)
    const body = cleaned.slice(0, -1)
    const dv = cleaned.slice(-1)
    let formattedBody = ''
    for (let i = body.length - 1, j = 1; i >= 0; i--, j++) {
      formattedBody = body[i] + formattedBody
      if (j % 3 === 0 && i !== 0) {
        formattedBody = '.' + formattedBody
      }
    }
    if (body.length === 0) return dv
    return `${formattedBody}-${dv}`
  }

  const toggleRowFromAnySource = (rowOrigen, item) => {
  const rowId = getRowId(item)
  const checked = !selectedCheckboxes[rowId]

  // 1) selectedCheckboxes
  setSelectedCheckboxes(prev => ({ ...prev, [rowId]: checked }))

  // 2) selectedDataByOrigen
  setSelectedDataByOrigen(prev => {
    const next = { ...prev }

    if (checked) {
      const arr = next[rowOrigen] || []
      if (!arr.some(r => getRowId(r) === rowId)) {
        next[rowOrigen] = [...arr, { ...item, _origen: rowOrigen }]
      }
    } else {
      for (const k of Object.keys(next)) {
        next[k] = (next[k] || []).filter(r => getRowId(r) !== rowId)
      }
    }

    return next
  })

  // 3) selectedIds
  setSelectedIds(prev => ({
    ...prev,
    [rowOrigen]: checked
      ? [...(prev[rowOrigen] || []), rowId]
      : (prev[rowOrigen] || []).filter(id => id !== rowId)
  }))

  // 4) unselectedIds → para desvincular
  setUnselectedIds(prev => {
    const n = toNumId(rowId)
    if (n === null) return prev

    const arr = prev[rowOrigen] || []

    return {
      ...prev,
      [rowOrigen]: checked
        ? arr.filter(id => id !== n) // si marco → quitar de desmarcados
        : isLinkedOnServerByRowId(rowId)
          ? arr.includes(n) ? arr : [...arr, n] // si desmarco y estaba vinculado → agregar
          : arr
    }
  })
}


  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      size="large" 
      footer={
        <>
          <Button
            onClick={handleClose}
            className='text-[10px] bg-primary text-white rounded-full'
            title='Cerrar'
          />
          <Button
            className='text-[10px] bg-accent2 text-white rounded-full'
            title='Guardar Conciliación'
            onClick={() => {
              if (rowsToShow.length === 0 && Object.values(unselectedIds).some(ids => ids.length > 0)) {
                handleSubmit()
                return
              }

              const montoPorSaldar = saldoRestante

              if (montoPorSaldar > 0) {
                setPopupMessage('El monto conciliado es inferior al saldo pendiente.')
                setShowConfirmPopup(true)
              } else if (montoPorSaldar < 0) {
                setPopupMessage('El monto conciliado supera el saldo pendiente.')
                setShowConfirmPopup(true)
              } else {
                handleSubmit()
              }
            }}
          />
        </>
      }
    >
      <>
        {loading ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
          </Box>
        ) : (
          <>
            <div className='flex w-full h-full gap-4'>
              {/* LISTA IZQUIERDA */}
              <div className="flex-1 h-full w-[65%]">
                <ListVincularArriendo
                  documentMovementType={documentMovementType}
                  idLibro={cuotaPrestamo ? cuotaPrestamo.idCuota : idLibro}
                  onSelectMovimiento={handleSeleccionarMovimiento}
                  type={type}
                  onInitialSelectedIds={setInitialSelectedIds}
                  setSwitchGetData={setSwitchGetData}
                  dataModal={dataDocumentoSeleccionado || row}
                  dataLinkage={linkageDocumentoSeleccionado}
                  reconciliationDetail={f29ReconciliationDetail}
                  selectedBank={selectedBank}
                  setSelectedBank={setSelectedBank}
                  modalStatus={status}
                  onCurrentDataBanco={handleCurrentData('banco')}
                  onCurrentDataCaja={handleCurrentData('caja')}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                  useCajaPrincipal={useCajaPrincipal}
                  setUseCajaPrincipal={setUseCajaPrincipal}
                  origenSeleccionado={origenSeleccionado}
                  setOrigenSeleccionado={setOrigenSeleccionado}
                  selectedCheckboxes={selectedCheckboxes}
                  setSelectedCheckboxes={setSelectedCheckboxes}
                  selectedDataByOrigen={selectedDataByOrigen}
                  setSelectedDataByOrigen={setSelectedDataByOrigen}
                  unselectedIds={unselectedIds}
                  setUnselectedIds={setUnselectedIds}
                  getRowId={getRowId}
                  nombreOrigen={nombreOrigen}
                  folioCredito={folioCredito}
                  montoReferencia={montoDocumentoSeleccionado}
                  onToggle={(item) => toggleRowFromAnySource(item._origen, item)}
                />
              </div>
              <div className='flex flex-col w-[35%] h-full font-sans font-medium'>
                <div className='flex-1 flex flex-col bg-white rounded-3xl shadow-lg p-2 text-[11px] overflow-auto'>
                  <div className='flex justify-between items-start mb-1'>
                    <div className='flex gap-2'>
                      <div className='flex flex-col'>
                        {/* --- Si existe row, muestro SOLO row --- */}
                        {nombreDocumentoSeleccionado ? (
                          <>
                            <p className='text-[12px] font-bold uppercase leading-5'>
                              {nombreDocumentoSeleccionado}
                            </p>
                            <div className='flex items-center gap-1 text-[13px] leading-tight'>
                              <span>{formatDate(row?.fecha ?? data.fecha)}</span>
                            </div>
                          </>
                        ) : row ? (
                          <>
                            <p className='text-[12px] font-bold uppercase leading-tight'>
                              {row.nombreCuenta}
                            </p>
                            <div className='flex items-center gap-1 text-[13px] leading-tight'>
                              <span>{formatDate(row.fecha)}</span>
                            </div>
                            {row.glosa && (
                              <p className='text-[12px] italic text-gray-600 leading-tight'>
                                Glosa: {row.glosa}
                              </p>
                            )}
                          </>
                        ) : (
                          <>
                            {/* --- Si no hay row, muestro lo de data original --- */}
                            <p className='text-[12px] font-bold uppercase leading-5'>
                              {mapFolio[folioCredito] || 'Folio ' + data.folio || 'Folio Desconocido' }
                            </p>
                            <div className='flex items-center gap-1 text-[13px] leading-tight'>
                              <span>{formatDate(data.fecha)}</span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Monto */}
                    <div className='flex flex-col items-end text-right pt-2 w-full lg:w-auto'>
                      <div className='flex items-center gap-1 text-[12px] font-semibold leading-tight'>
                        <span>
                          {formatCurrency(montoDocumentoSeleccionado)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Pie de la tarjeta */}
                  <div className='flex flex-col md:flex-row md:justify-between md:items-center gap-2 md:gap-10 mt-2 border-b pb-1'>
                    <div className='w-full md:w-auto'>
                      {!isFormulario29 && (
                        <p className='text-[12px] font-semibold leading-tight'>
                          {data.razonSocial}
                        </p>
                      )}
                      <p className='text-[12px] font-semibold leading-tight'>
                        {formatRut(data.rut)}
                      </p>
                    </div>
                    <Text
                      className={`text-[12px] font-semibold leading-tight ${
                        estadoDocumento === 'POR PAGAR' || estadoDocumento === 'POR COBRAR'
                          ? 'text-accent3'
                          : 'text-accent2'
                      }`}
                    >
                      {estadoDocumento}
                    </Text>
                  </div>
                  <div className='flex-1 overflow-auto font-sans font-medium'>
                    {rowsToShow.map(

                      (item, idx) => (
                        <div
                          key={getConciliationRenderKey(item)}
                          className='flex justify-between items-center text-gray-700 py-1 border-b last:border-0'
                        >
                          <div className='flex items-center gap-4'>
                           <input
                            type='checkbox'
                            className='rounded'
                            checked={Object.values(selectedDataByOrigen)
                              .flat()
                              .some(r => getRowId(r) === getRowId(item))}
                            onChange={e => {
                              const checked = e.target.checked
                              const rowId = getRowId(item)
                              const rowOrigen =
                                item._origen || item.origen || item.tipo || origenSeleccionado[0]

                              // 1) Actualiza selección por origen (add/remove)
                              setSelectedDataByOrigen(prev => {
                                const next = { ...prev }
                                if (checked) {
                                  const arr = next[rowOrigen] || []
                                  if (!arr.some(r => getRowId(r) === rowId)) {
                                    next[rowOrigen] = [...arr, { ...item, _origen: rowOrigen }]
                                  }
                                } else {
                                  for (const k of Object.keys(next)) {
                                    next[k] = (next[k] || []).filter(r => getRowId(r) !== rowId)
                                  }
                                }
                                return next
                              })

                              // 2) Actualiza selectedIds por origen
                              setSelectedIds(prev => {
                                const arr = prev[rowOrigen] || []
                                return {
                                  ...prev,
                                  [rowOrigen]: checked
                                    ? [...arr, rowId]
                                    : arr.filter(id => id !== rowId)
                                }
                              })

                              // 3) Estado de los checkboxes
                              setSelectedCheckboxes(prev => ({
                                ...prev,
                                [rowId]: checked
                              }))

                              // 4) Mantener unselectedIds por origen
                              setUnselectedIds(prev => {
                                const n = toNumId(rowId)
                                if (n === null) return prev

                                const arr = prev[rowOrigen] || []
                                return {
                                  ...prev,
                                  [rowOrigen]: checked
                                    ? arr.filter(id => id !== n)
                                    : isLinkedOnServerByRowId(rowId)
                                      ? arr.includes(n)
                                        ? arr
                                        : [...arr, n]
                                      : arr
                                }
                              })
                            }}
                          />
                            {item.nombreFolio ? (
                              ''
                            ) : (
                              item.nombreCuentaBanco && (
                                <img
                                  src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank}
                                  alt={item.nombreCuentaBanco}
                                  className='w-8 h-8'
                                />
                              )
                            )}

                            <div className='flex flex-col leading-tight '>
                              <span>
                                {item.nombreCuentaBanco}
                              </span>
                              <span>
                                {getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco || item.numeroFolio)}
                              </span>
                            </div>
                            <span>{item.descripcion || item.razonSocial || item.glosa}</span>
                            <span>{formatDate(getMovementDate(item))}</span>
                          </div>
                          <div className='flex items-center'>
                          {(() => {
                            if (getConciliationAdjustmentDisplay(item)) return <ConciliationAdjustmentAmount movement={item} documentTotal={totalDocumento} formatCurrency={formatCurrency} />
                            const isCajaItem =
                              item?._origen === 'caja' ||
                              item?.tipo === 'caja' ||
                              item?.nombreCuentaBanco?.toLowerCase?.().includes('caja')
                            const isGestionItem =
                              item?._origen === 'gestion' ||
                              item?.customRow === true ||
                              item?.tipo === 'gestion'

                            if (!isCajaItem && !isGestionItem) {
                              const originalRow = Object.values(selectedDataByOrigen).flat().find(row =>
                                String(getRowId(row)) === String(getRowId(item))) ?? item
                              const originalAmount = getVinculacionAvailableAmount(originalRow)
                              const baseline = getLinkedItem(item)
                                ? getVinculacionAppliedAmount(item, getLinkedItem(item)) : getVinculacionAvailableAmount(item)
                              return (
                                <div className='flex flex-col text-right gap-1'>
                                  <span className='text-gray-400'>Disponible Asignado</span>
                                  <AssignedAmountInput
                                    aria-label={`Monto seleccionado ${getRowId(item)}`}
                                    className='border rounded-full text-xs text-right px-2 py-1 w-28 self-end'
                                    value={editedAmounts[getRowId(item)] ?? baseline}
                                    min={1}
                                    max={originalAmount}
                                    onCommit={value => {
                                      const amount = Number(value)
                                      if (amount <= 0 || amount > originalAmount) return
                                      setEditedAmounts(previous => {
                                        const next = { ...previous }
                                        if (amount === baseline) delete next[getRowId(item)]
                                        else next[getRowId(item)] = amount
                                        return next
                                      })
                                    }}
                                  />
                                 {/* <span className='text-gray-400'>Monto original: {formatCurrency(originalAmount)}</span>*/}
                                </div>
                              )
                            }

                            const origen =
                              item._origen || (isCajaItem ? 'caja' : isGestionItem ? 'gestion' : null)
                            const rowId = getRowId(item)
                            const currentRows = selectedDataByOrigen[origen] || []
                            const selectedItem = currentRows.find(r => getRowId(r) === rowId)
                            const isEditableMonto =
                              (selectedItem?.customRow ?? item?.customRow) === true

                            if (!isEditableMonto) {
                              const montoDisplay = Math.abs(
                                selectedItem?.montoEditable ??
                                  item?.montoEditable ??
                                  item?.montoAbono ??
                                  item?.montoCargo ??
                                  item?.montoRelacionado ??
                                  item?.montoTotal ??
                                  item?.amount ??
                                  0
                              )
                              return (
                                <span className='text-right w-20'>
                                  {formatCurrency(montoDisplay)}
                                </span>
                              )
                            }

                            const montoValueRaw =
                              selectedItem?.montoEditable ??
                              item?.montoEditable ??
                              item?.montoAbono ??
                              item?.montoCargo ??
                              item?.montoTotal ??
                              item?.amount ??
                              0
                            const montoValue = Math.abs(montoValueRaw)

                            return (
                              <input
                                key={`${origen}-${rowId}`}
                                type='text'
                                inputMode='numeric'
                                className='border rounded-full text-xs text-right px-1 py-0.5 w-20
                                  [appearance:textfield]
                                  [&::-webkit-outer-spin-button]:appearance-none
                                  [&::-webkit-inner-spin-button]:appearance-none'
                                value={`$ ${Number(montoValue).toLocaleString('es-CL')}`}
                                onFocus={e => {
                                  e.target.value = montoValue.toString()
                                }}
                                onBlur={e => {
                                  const raw = e.target.value.replace(/[^\d]/g, '')
                                  e.target.value = `$ ${Number(raw || 0).toLocaleString('es-CL')}`
                                }}
                                onChange={e => {
                                  const digits = e.target.value.replace(/[^\d]/g, '')
                                  const newValue = Number(digits || 0)
                                  setSelectedDataByOrigen(prev => {
                                    const clonedPrev = structuredClone(prev)
                                    const current = clonedPrev[origen] || []
                                    const updated = current.map(r =>
                                      getRowId(r) === rowId ? { ...r, montoEditable: newValue } : r
                                    )
                                    return { ...clonedPrev, [origen]: updated }
                                  })
                                }}
                              />
                            )
                          })()}
                        </div>
                        </div>
                      ))}
                  </div>
                      <div className='flex justify-between border-t text-sm font-semibold mt-2 pt-1 shrink-0'>
                        <span>Monto Saldado</span>
                        <span>{formatCurrency(Math.max(totalDocumento - Math.max(saldoRestante, 0), 0))}</span>
                      </div>
                      <div className='flex justify-between mt-1 text-sm font-semibold text-accent2 shrink-0'>
                        <span>Diferencia</span>
                        <span>{saldoRestante === 0 ? '$0' : formatCurrency(saldoRestante)}</span>
                      </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
      <ConfirmConciliationModal
        difference={saldoRestante}
        onGenerateAdjustment={ajuste => {
          setShowConfirmPopup(false)
          handleSubmit(ajuste)
        }}
        open={showConfirmPopup}
        message={popupMessage}
        onClose={() => setShowConfirmPopup(false)}
        actions={[
          { id: 'back', title: 'Volver', onClick: () => setShowConfirmPopup(false) },
          {
            id: 'save',
            title: 'Guardar',
            className: 'rounded-full bg-accent2 px-5 text-sm text-white',
            onClick: () => {
              setShowConfirmPopup(false)
              handleSubmit()
            }
          }
        ]}
      />
    </ResizableModal>
  )
}

export default ModalConciliarVinculacion
